import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-professional-bodies-ec.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-professional-bodies-ec.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationProfessionalBodiesEcConstants } from "./create-application-professional-bodies-ec.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../shared/models/alert";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateApplicationProfessionalBodiesEcComponent = class CreateApplicationProfessionalBodiesEcComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    searchApplicationsService;
    professionalBodiesForm;
    professionalBodiesFormControlName = CreateApplicationProfessionalBodiesEcConstants.PROFESSIONAL_BODY_FORM_CONTROL_NAME;
    markEngineerAsRequiredLabel = CreateApplicationProfessionalBodiesEcConstants.MARK_ENGINEER_REQUIRED_LABEL;
    markEngineerAsRequiredFormControlName = CreateApplicationProfessionalBodiesEcConstants.MARK_ENGINEER_AS_REQUIRED_FORM_CONTROL_NAME;
    copyApplicantDetailsToElectricalContractorLabel = CreateApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL;
    copyApplicantDetailsToElectricalContractorFormControlName = CreateApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    markElectricalContractorAsRequiredLabel = CreateApplicationProfessionalBodiesEcConstants.MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_LABEL;
    markElectricalContractorAsRequiredFormControlName = CreateApplicationProfessionalBodiesEcConstants.MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerLabel = CreateApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL;
    copyApplicantDetailsToEngineerFormControlName = CreateApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME;
    architectFormControlName = CreateApplicationProfessionalBodiesEcConstants.ARCHITECT_FORM_CONTROL_NAME;
    engineerFormControlName = CreateApplicationProfessionalBodiesEcConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = CreateApplicationProfessionalBodiesEcConstants.ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    showArchitect = false;
    showEngineer = false;
    showElectricalContractor = false;
    architectDisableFilterBy = true;
    architectDisableEditing = false;
    architectShowFields = true;
    architectGroups = [];
    architectLabel = CreateApplicationProfessionalBodiesEcConstants.ARCHITECT_LABEL;
    architectShowGroupsDropdown = false;
    architectIsRequiredChecked = false;
    engineerDisableFilterBy = true;
    engineerDisableAdd = true;
    engineerDisableEditing = false;
    engineerShowFields = true;
    engineerIsInternal = false;
    engineerGroups = [];
    engineerLabel = CreateApplicationProfessionalBodiesEcConstants.ENGINEER_LABEL;
    engineerShowGroupsDropdown = false;
    engineerIsRequiredChecked = false;
    contractorDisableFilterBy = true;
    contractorDisableAdd = true;
    contractorDisableEditing = false;
    contractorShowFields = true;
    contractorIsInternal = false;
    contractorGroups = [];
    contractorLabel = CreateApplicationProfessionalBodiesEcConstants.ELECTRICAL_CONTRACTOR_LABEL;
    contractorShowGroupsDropdown = false;
    contractorIsRequiredChecked = false;
    applicant;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
        this.getApplicantData();
        this.getMetadata();
    }
    ngOnInit() {
        this.initForm();
        this.initialiseDefaultValues();
        this.populateProfessionalBodiesForms();
    }
    loadMetadata(stepMeta) {
        try {
            this.engineerGroups = stepMeta.engineerGroup;
            this.contractorGroups = stepMeta.electricalContractorGroup;
            this.changeDetectorRefs.markForCheck();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(this.professionalBodiesFormControlName);
        form.clearValidators();
        form.updateValueAndValidity();
        this.professionalBodiesForm = form;
    }
    onCopyApplicantToEngineer($event) {
        const copyApplicantDataChecked = $event.target.checked;
        if (copyApplicantDataChecked) {
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            const applicantData = this.applicant;
            if (this.selectedApplication && this.selectedApplication.engineer > 0 && this.selectedApplication.engineer[0].id >= 0) {
                applicantData.id = this.selectedApplication.engineer[0].id;
            }
            else {
                applicantData.id = 0;
            }
            // applicantData.id = ((this.selectedApplication.engineer > 0 && this.selectedApplication.engineer[0].id >= 0)) ? this.selectedApplication.engineer[0].id : 0;
            applicantData.groups = this.engineerGroups;
            this.professionalBodiesForm.get(this.engineerFormControlName).setValue(applicantData);
        }
        else {
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
        }
    }
    onCopyApplicantToElectricalContractor($event) {
        const copyApplicantDataChecked = $event.target.checked;
        if (copyApplicantDataChecked) {
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            const applicantData = this.applicant;
            if (this.selectedApplication && this.selectedApplication.electricalContractor > 0 && this.selectedApplication.electricalContractor[0].id >= 0) {
                applicantData.id = this.selectedApplication.electricalContractor[0].id;
            }
            else {
                applicantData.id = 0;
            }
            // applicantData.id = (this.selectedApplication.electricalContractor > 0 && this.selectedApplication.electricalContractor[0].id >= 0) ? this.selectedApplication.electricalContractor[0].id : 0;
            applicantData.groups = this.contractorGroups;
            this.professionalBodiesForm.get(this.contractorFormControlName).setValue(applicantData);
        }
        else {
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
        }
    }
    populateProfessionalBodiesForms() {
        const selectedApplication = this.selectedApplication;
        this.populateEngineer(selectedApplication);
        this.populateElectricalContractor(selectedApplication);
    }
    populateEngineer(selectedApplication) {
        const engineerControl = this.professionalBodiesForm.get(this.engineerFormControlName);
        this.professionalBodiesForm.get(this.engineerFormControlName).reset();
        if (selectedApplication.engineer && selectedApplication.engineer.length > 0) {
            const engineer = selectedApplication.engineer[0];
            engineer.groups.forEach(group => {
                if (group?.hasOwnProperty("requiredFields")) {
                    delete group.requiredFields;
                }
            });
            engineerControl.setValue(engineer);
        }
    }
    populateElectricalContractor(selectedApplication) {
        const electricalContractorControl = this.professionalBodiesForm.get(this.contractorFormControlName);
        this.professionalBodiesForm.get(this.contractorFormControlName).reset();
        if (selectedApplication.electricalContractor && selectedApplication.electricalContractor.length > 0) {
            const electricalContractor = selectedApplication.electricalContractor[0];
            electricalContractor.groups.forEach(group => {
                if (group?.hasOwnProperty("requiredFields")) {
                    delete group.requiredFields;
                }
            });
            electricalContractorControl.setValue(electricalContractor);
        }
    }
    getApplicantData() {
        if (this.selectedApplication) {
            this.applicant = this.selectedApplication.applicant[0];
        }
    }
    initialiseDefaultValues() {
        this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(false);
        this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationProfessionalBodiesEcComponent = __decorate([
    Component({
        selector: "app-create-application-professional-bodies-ec",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationProfessionalBodiesEcComponent);
export { CreateApplicationProfessionalBodiesEcComponent };
